module.exports = __webpack_public_path__ + "static/media/Cheque_Status.30bb93da.svg";